import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit';

import * as styles from './tooltipContent.css';

export const TooltipContent = ({ description, tracking }: { description: string; tracking(): void }) => {
  React.useEffect(() => {
    const id = setTimeout(tracking, 3000);

    return () => clearTimeout(id);
  }, []);

  return (
    <div className={styles['tooltip']}>
      <InlineText2>{description}</InlineText2>
    </div>
  );
};

TooltipContent.displayName = 'TooltipContent';
